import toast from 'react-hot-toast'

export const successToast = (message: string) => {
  toast.success(message, {
    duration: 4000,
  })
}

export const errorToast = (message: string) => {
  toast.error(message, {
    duration: 6000,
  })
}

export const infoToast = (message: string) => {
  toast(message, {
    duration: 4000,
  })
}

